interface LoaderConfig {
    bodyClass?: string | string[];
}

/**
 * Executes a callback on certain events, such as when a body class is found.
 */
export class Loader {
    /**
     * A stupid loader.
     *
     * @param config Pass null to execute callback on all pages
     * @param callback
     */
    static on(config: LoaderConfig | null, callback: () => void) {
        if (config === null) {
            callback();
            return;
        }

        let bodyClasses: string[] = [];
        if (config.bodyClass && !Array.isArray(config.bodyClass)) {
            bodyClasses.push(config.bodyClass);
        } else {
            bodyClasses = config.bodyClass as string[];
        }

        if (config.bodyClass && bodyClasses.some(s => document.body.classList.contains(s))) {
            callback();
        }
    }
}
